import { RuleValidator } from '../types';
import {allRules} from "./index";

export const conditionalRules: Record<string, RuleValidator> = {
    requiredIf: (value: any, params: any[], data: Record<string, any>): boolean => {
        const [field, expectedValue] = params;
        const fieldValue = data[field];

        if (fieldValue === expectedValue) {
            return value !== undefined && value !== null && value !== '';
        }

        return true;
    },

    requiredUnless: (value: any, params: any[], data: Record<string, any>): boolean => {
        const [field, expectedValue] = params;
        const fieldValue = data[field];

        if (fieldValue !== expectedValue) {
            return value !== undefined && value !== null && value !== '';
        }

        return true;
    },

    requiredWith: (value: any, params: any[], data: Record<string, any>): boolean => {
        const field = params[0];
        const fieldValue = data[field];

        if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
            return value !== undefined && value !== null && value !== '';
        }

        return true;
    },

    requiredWithAll: (value: any, params: string[], data: Record<string, any>): boolean => {
        const allFieldsPresent = params.every(field => {
            const fieldValue = data[field];
            return fieldValue !== undefined && fieldValue !== null && fieldValue !== '';
        });

        if (allFieldsPresent) {
            return value !== undefined && value !== null && value !== '';
        }

        return true;
    },

    requiredWithout: (value: any, params: any[], data: Record<string, any>): boolean => {
        const field = params[0];
        const fieldValue = data[field];

        if (fieldValue === undefined || fieldValue === null || fieldValue === '') {
            return value !== undefined && value !== null && value !== '';
        }

        return true;
    },

    requiredWithoutAll: (value: any, params: string[], data: Record<string, any>): boolean => {
        const allFieldsMissing = params.every(field => {
            const fieldValue = data[field];
            return fieldValue === undefined || fieldValue === null || fieldValue === '';
        });

        if (allFieldsMissing) {
            return value !== undefined && value !== null && value !== '';
        }

        return true;
    },

    same: (value: any, params: any[], data: Record<string, any>): boolean => {
        if (value === undefined || value === null || value === '') return true;
        const otherField = params[0];
        const otherValue = data[otherField];
        return value === otherValue;
    },

    different: (value: any, params: any[], data: Record<string, any>): boolean => {
        if (value === undefined || value === null || value === '') return true;
        const otherField = params[0];
        const otherValue = data[otherField];
        return value !== otherValue;
    },

    gt: (value: any, params: any[], data: Record<string, any>): boolean => {
        if (value === undefined || value === null || value === '') return true;
        const otherField = params[0];
        const otherValue = data[otherField];

        if (typeof value === 'number' && typeof otherValue === 'number') {
            return value > otherValue;
        }

        return String(value).length > String(otherValue).length;
    },

    gte: (value: any, params: any[], data: Record<string, any>): boolean => {
        if (value === undefined || value === null || value === '') return true;
        const otherField = params[0];
        const otherValue = data[otherField];

        if (typeof value === 'number' && typeof otherValue === 'number') {
            return value >= otherValue;
        }

        return String(value).length >= String(otherValue).length;
    },

    lt: (value: any, params: any[], data: Record<string, any>): boolean => {
        if (value === undefined || value === null || value === '') return true;
        const otherField = params[0];
        const otherValue = data[otherField];

        if (typeof value === 'number' && typeof otherValue === 'number') {
            return value < otherValue;
        }

        return String(value).length < String(otherValue).length;
    },

    lte: (value: any, params: any[], data: Record<string, any>): boolean => {
        if (value === undefined || value === null || value === '') return true;
        const otherField = params[0];
        const otherValue = data[otherField];

        if (typeof value === 'number' && typeof otherValue === 'number') {
            return value <= otherValue;
        }

        return String(value).length <= String(otherValue).length;
    },

    when: (value: any, params: any[], data: Record<string, any>): boolean => {
        const [condition, nestedRules] = params;

        if (condition(data)) {
            for (const rule of nestedRules) {
                const ruleValidator = allRules[rule.rule];
                if (ruleValidator) {
                    const ruleParams = rule.value !== undefined ? [rule.value].flat() : [];
                    const result = ruleValidator(value, ruleParams, data);
                    if (result !== true) return false;
                }
            }
        }

        return true;
    },

    requiredIfAny: (value: any, params: Array<{ field: string; value: any }>, data: Record<string, any>): boolean => {
        const anyConditionMet = params.some(condition => {
            const fieldValue = data[condition.field];
            return fieldValue == condition.value;
        });

        if (anyConditionMet) {
            return value !== undefined && value !== null && value !== '';
        }

        return true;
    },

    requiredIfAll: (value: any, params: Array<{ field: string; value: any }>, data: Record<string, any>): boolean => {
        const allConditionsMet = params.every(condition => {
            const fieldValue = data[condition.field];
            return fieldValue == condition.value;
        });

        if (allConditionsMet) {
            return value !== undefined && value !== null && value !== '';
        }

        return true;
    }
};